/*
 * Copyright (c) RECREWT GmbH 2022.
 */

import { Component, Input } from '@angular/core';

export interface StatusTagConfig {
  backgroundColor: string;
  color: string;
  text: string;
  desc?: string;
  icon?: string;
  arg?: any;
}

@Component({
  selector: 'recrewt-status-tag',
  templateUrl: './status-tag.component.html',
  styleUrls: ['./status-tag.component.scss'],
  standalone: false,
})
export class StatusTagComponent {
  @Input() config?: StatusTagConfig;
}
